import React, { forwardRef, memo, useContext, useMemo } from 'react';
import classNames from 'classnames';
import { CopilotContext } from '@Sage/ssm-web5';

import useEntityDetail from './hooks/useEntityDetail';

const EntityDetailContent = forwardRef(({ children, onScroll, bottomSpacing = 0 }, ref) => {
    const { hasTabs } = useEntityDetail();
    const { copilotBarProps } = useContext(CopilotContext);
    const {
        height: copilotBarHeight,
        isMinimized: isCopilotBarMinimized,
        isOpen: isCopilotBarOpen,
        padding: copilotBarPadding,
    } = copilotBarProps;

    const copilotBottomInset = useMemo(() => {
        if (!isCopilotBarOpen || isCopilotBarMinimized) {
            return 0;
        }
        return copilotBarPadding * 2 + copilotBarHeight;
    }, [copilotBarHeight, copilotBarPadding, isCopilotBarMinimized, isCopilotBarOpen]);

    const totalBottomInset = useMemo(() => {
        return copilotBottomInset + bottomSpacing;
    }, [bottomSpacing, copilotBottomInset]);

    const shouldApplyBottomInset = totalBottomInset > 0;

    const innerStyle = useMemo(() => {
        if (!shouldApplyBottomInset) return undefined;
        return { marginBottom: totalBottomInset };
    }, [shouldApplyBottomInset, totalBottomInset]);

    return (
        <div
            className={classNames('fm-entity-detail__content', {
                'fm-entity-detail__content--withTabs': hasTabs,
            })}
            ref={ref}
            onScroll={onScroll}
        >
            <div className="fm-entity-detail__content__inner" style={innerStyle}>
                {children}
            </div>
        </div>
    );
});

export default memo(EntityDetailContent);
